import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ToBoolean } from '@shared/decorators/to-boolean';

@Component({
  imports: [CommonModule],
  standalone: true,
  selector: 'app-fancy-navigator',
  templateUrl: './fancy-navigator.component.html',
  styleUrls: ['./fancy-navigator.component.scss'],
})
export class FancyNavigatorComponent implements OnInit {
  @Input() link_text: string = '';
  @Input() link_url: string = '';
  @Input() link_target: string = '_self';
  @Input() @ToBoolean() standalone_widget_mode = false;

  showButton = false;
  private lastScrollTop = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > this.lastScrollTop && st > 100) {
      // Scroll Down
      this.showButton = true;
    } else {
      // Scroll Up or Back to Top
      this.showButton = false;
    }
    this.lastScrollTop = st <= 0 ? 0 : st;
  }

  constructor() {}

  ngOnInit(): void {
    // Initialize component
  }

  get buttonClasses(): string {
    return 'btn btn-primary fancy-navigator-btn';
  }
}
